import { BRAND } from "@/lib/colors";

export const TIER_COLORS = {
  high: BRAND.red,
  watch_list: BRAND.orange,
  on_track: BRAND.blue,
  excellent: BRAND.green,
} as const;

export const TIER_LABELS = {
  high: "High Priority",
  watch_list: "Watch List",
  on_track: "On Track",
  excellent: "Excellent",
} as const;

export type TierKey = keyof typeof TIER_COLORS;

export const ACCENT_ORANGE = BRAND.orange;
export const ACCENT_BLUE = BRAND.blue;
export const ACCENT_GREEN = BRAND.green;
export const ACCENT_RED = BRAND.red;

export function extendedRateAccent(rate: number): string {
  if (rate >= 40) return ACCENT_RED;
  if (rate >= 25) return ACCENT_ORANGE;
  if (rate >= 10) return ACCENT_BLUE;
  return ACCENT_GREEN;
}

export function fleetIdleRateAccent(rate: number): string {
  if (rate >= 75) return ACCENT_RED;
  if (rate >= 50) return ACCENT_ORANGE;
  if (rate >= 25) return ACCENT_BLUE;
  return ACCENT_GREEN;
}
